{
  "name": "@retracedgmbh/frontend",
  "version": "2.841.0",
  "private": true,
  "license": "UNLICENSED",
  "type": "module",
  "scripts": {
    "build": "doppler run -p platform -c development --command=\"NODE_OPTIONS=--max-old-space-size=4096 pnpm --filter @retracedgmbh/ui-components-lib build && vite build\"",
    "build-ci": "pnpm run build-ci:ui-lib && pnpm run build-ci:frontend",
    "build-ci:ui-lib": "cross-env NODE_OPTIONS=--max-old-space-size=4096 pnpm --filter @retracedgmbh/ui-components-lib build",
    "build-ci:frontend": "cross-env NODE_OPTIONS=--max-old-space-size=8192 vite build",
    "dev": "doppler run -p platform -c development --command=\"vite --host --force\"",
    "dev-edo": "vite --host --force",
    "dev-builder": "doppler run -p platform -c development_frontend_target_staging --command=\"vite --host --force\"",
    "serve": "vite preview",
    "serve2": "doppler run -p platform --command=\"vite preview\"",
    "start": "DEBUG=vite:deps vite --force",
    "test": "vitest run",
    "test:watch": "vitest",
    "test:coverage": "vitest run --coverage",
    "lint": "biome check .",
    "lint:fix": "biome check --write .",
    "lint:imports": "../scripts/check-react-query-imports.sh $(find src -name '*.ts' -o -name '*.tsx' -o -name '*.js' -o -name '*.jsx')",
    "lint:imports:staged": "../scripts/check-react-query-imports.sh"
  },
  "browserslist": [
    "> 2%",
    "last 2 versions",
    "not IE 11",
    "not OperaMini all",
    "not dead"
  ],
  "dependencies": {
    "@datadog/browser-core": "6.33.0",
    "@datadog/browser-rum": "6.33.0",
    "@datadog/browser-rum-core": "6.33.0",
    "@getnuvo/importer-react": "3.0.0",
    "@hookform/error-message": "2.0.1",
    "@hookform/resolvers": "3.10.0",
    "@intercom/messenger-js-sdk": "0.0.19",
    "@popperjs/core": "catalog:",
    "@react-spring/web": "9.7.5",
    "@retracedgmbh/data-points-lib": "catalog:",
    "@retracedgmbh/modules": "workspace:*",
    "@retracedgmbh/ui-components-lib": "workspace:*",
    "@tailwindcss/vite": "catalog:",
    "@tanstack/react-query": "5.100.14",
    "@tanstack/react-query-devtools": "5",
    "ahooks": "3.9.5",
    "classnames": "catalog:",
    "compute-scroll-into-view": "1.0.17",
    "cross-env": "7.0.3",
    "dagre": "0.8.5",
    "date-fns": "catalog:",
    "entities": "6.0.1",
    "fetch-event-stream": "0.1.5",
    "i18next": "24.2.3",
    "i18next-browser-languagedetector": "7.2.1",
    "i18next-http-backend": "3.0.5",
    "install": "0.13.0",
    "jwt-decode": "4.0.0",
    "lodash-es": "4.18.1",
    "rc-util": "5.44.4",
    "react": "catalog:",
    "react-beautiful-dnd": "13.1.1",
    "react-circular-progressbar": "catalog:",
    "react-dom": "catalog:",
    "react-dropzone": "catalog:",
    "react-hook-form": "7.57.0",
    "react-i18next": "13.5.0",
    "react-json-view": "1.21.3",
    "react-json-view-compare": "2.0.2",
    "react-loading-skeleton": "3.5.0",
    "react-markdown": "10.1.0",
    "react-router-dom": "7.6.1",
    "react-virtualized": "9.22.6",
    "reactflow": "11.11.4",
    "recharts": "2.15.3",
    "regenerator-runtime": "0.14.1",
    "rehype-raw": "7.0.0",
    "scroll-into-view-if-needed": "2.2.28",
    "spark-md5": "^3.0.2",
    "tailwindcss-animate": "catalog:",
    "ulid": "catalog:",
    "uuid": "catalog:",
    "yup": "1.6.1",
    "zustand": "4.5.5"
  },
  "devDependencies": {
    "@biomejs/biome": "catalog:",
    "@cucumber/cucumber": "11.3.0",
    "@datadog/datadog-ci": "5.14.0",
    "@fullhuman/postcss-purgecss": "catalog:",
    "@tailwindcss/typography": "0.5.19",
    "@testing-library/jest-dom": "6.9.1",
    "@testing-library/react": "16.3.2",
    "@testing-library/user-event": "catalog:",
    "@types/spark-md5": "*",
    "@vitejs/plugin-react": "6.0.2",
    "@vitest/coverage-v8": "catalog:",
    "babel-loader": "9.2.1",
    "babel-plugin-transform-react-remove-prop-types": "0.4.24",
    "esbuild": "catalog:",
    "esbuild-plugin-react-virtualized": "1.0.5",
    "jest-environment-jsdom": "29.7.0",
    "jsdom": "25.0.1",
    "jsdom-global": "3.0.2",
    "msw": "2.14.2",
    "nanoid": "catalog:",
    "postcss": "catalog:",
    "sass": "catalog:",
    "tailwindcss": "catalog:",
    "tsx": "catalog:",
    "typescript": "catalog:",
    "vite": "catalog:",
    "vitest": "catalog:"
  },
  "engines": {
    "node": ">=24.0.0 <25.0.0"
  },
  "overrides": {
    "glob-to-regexp@<0.4.1": "0.4.1",
    "source-map-support@<0.5.21": "0.5.21"
  },
  "staticFiles": {
    "staticPath": "public"
  }
}
